import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as XCircleIcon } from './xCircle.svg';

export const XCircle = IconHOC(XCircleIcon);
